interface ProductNameProps {
  productLink: string;
  name: string;
}

export default function ProductName({ productLink, name }: ProductNameProps): JSX.Element {
  return (
    <h2 className="product-card__title">
      <a href={productLink}>
        {name}
      </a>
    </h2>
  );
}